const INVALID_FIELD_MSG = {
    EMAIL: 'E-mail inválido',
    PASSWORD: 'Senha inválida',
    PASSWORD_MIN_LEN: 'A nova senha precisa ter entre 6 e 10 caracteres.',
    PASSWORDS_DO_NOT_MATCH: 'Senhas não conferem.',
};

export {
    INVALID_FIELD_MSG,
}